import { render } from "./Form.vue?vue&type=template&id=08ee9d89&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=08ee9d89&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08ee9d89"

export default script